import React from "react";

/**
 * TransparentCard
 * A reusable translucent glassmorphism card container.
 *
 * Props:
 * - children: React.ReactNode
 * - as?: keyof JSX.IntrinsicElements | React.ComponentType<any> (default: 'div')
 * - className?: string
 * - radius?: number (default: 12)
 * - padding?: number (default: 16)
 * - style?: React.CSSProperties
 * - ...rest: any other props (like onClick)
 */
export default function TransparentCard({
                                          children,
                                          as: As = "div",
                                          className = "",
                                          radius = 12,
                                          padding = 16,
                                          style = {},
                                          ...rest
                                        }) {
  const mergedStyle = {
    borderRadius: radius,
    padding,
    ...style,
  };

  return (
      <As
          className={`glass-card-ui ${className}`.trim()}
          style={mergedStyle}
          {...rest} // forward onClick and any other props
      >
        {children}
      </As>
  );
}
